import React, { useContext, useEffect, useState } from "react";
import comp from "../component";
import { AppContext } from "../../../provider/AppProvider";
import { ProductContext } from "../provider";

let wrapper: HTMLElement = null;
function ProductPreview(): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { productPreview } = useContext(AppContext);
  const { printPaper } = useContext(ProductContext);

  const [wrapperHeight, setWrapperHeight] = useState<number | string>("auto");

  useEffect(() => {
    wrapper = document.getElementById("product-preview-wrap");
    window.addEventListener("resize", handleResize);
    resize();
  }, []);

  function handleResize() {
    resize();
  }

  function resize() {
    const { width, height } = wrapper.getBoundingClientRect();
    setWrapperHeight(width / (printPaper.width / printPaper.height));
  }

  return (
    <div
      id={"product-preview-wrap"}
      className={"product-section d-flex flex-column pt-4 pb-3 px-2"}>
      <p className={"mx-auto my-4"}>{t.paper_ready}</p>
      {productPreview && productPreview.jpg ? (
        <img
          className={"product-section__preview-img"}
          src={`${productPreview.jpg}`}
          alt=""
          onError={(e) => console.log(e)}
        />
      ) : (
        <p>{window.INITIAL_DATA.TRANSLATIONS.missing_preview_image}</p>
      )}
      <comp.ProductControls />
    </div>
  );
}

export default ProductPreview;
